/**
 * Permet de formater une date selon le résultat voulu
 * Exemple :
 * let a = [{day: 'numeric'}, {month: 'short'}, {year: 'numeric'}];
 * let s = join(new Date, a, '-');
 * console.log(s);
 * @param date
 * @param format
 * @param separator
 */
export function dateToString(date: Date, format: [], separator: string) {
    function formatMe(m: any) {
        let f = new Intl.DateTimeFormat('fr', m);
        return f.format(date);
    }
    return format.map(formatMe).join(separator);
}

export const DATE_FORMAT_WITH_TIME = {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'};
export const DATE_FORMAT_WITHOUT_TIME = {year: 'numeric', month: 'numeric', day: 'numeric'};


export function autoFormatDate(date: Date, formatDate:  any) {
    return new Date(date).toLocaleDateString("fr-FR", formatDate);
}

export function getRandomIntInclusive(min: number, max: number) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min +1)) + min;
}

export const KEY_FOR_HYBRID_PLATFORM = 'hybrid';

export const CSS_CLASS_NAME_ORANGE_MARKER = "orange-marker";
export const CSS_CLASS_NAME_GRAY_MARKER = "gray-marker";

